<!-- ЭДО -->
<template>
  <li
    v-if="canSeePage('edo_documents')"
    class="nav-item"
    role="button"
    tabindex="0"
    @click="navigate($event, 'EdoDocuments')"
    @mouseup="handleMiddleClick($event, 'EdoDocuments')"
    @contextmenu.prevent.stop="showContextMenu($event, 'EdoDocuments')"
    :class="{ active: activeItem === 'edo_documents' }"
    :title="collapsed ? 'ЭДО' : ''"
  >
    <div class="link-icon_box">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="#ffffff"
      >
        <path
          d="M12 2C9.79 2 8 3.79 8 6c0 1.5.84 2.79 2.07 3.46L9 14h6l-1.07-4.54C15.16 8.79 16 7.5 16 6c0-2.21-1.79-4-4-4zM5 15a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1H5zM4 21a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2H4z"
        />
      </svg>
    </div>
    <AppSidebarItemLabel
      label="ЭДО"
      :collapsed="collapsed"
      :show-new-badge="showNewBadge"
    />
  </li>
</template>

<script>
import AppSidebarItemLabel from "@/components/AppSidebar/ItemLabel.vue";
import {
  useSidebarItem,
  sidebarItemProps,
} from "@/composables/useSidebarItem";

export default {
  name: "EdoDocumentsItem",
  components: { AppSidebarItemLabel },
  props: sidebarItemProps,
  emits: ["navigate", "middle-click", "context-menu"],
  setup(props, { emit }) {
    return useSidebarItem(emit);
  },
};
</script>
